import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../redux/AsyncThunk";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/UiComponents";
import { FaChevronDown } from "react-icons/fa";

const LangSelector = ({
  dropdownPosition = "bottom-full",
  showTitle = true,
}) => {
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const dispatch = useDispatch();
  const userSelectedLanguage = useSelector(
    (state) => state.persist.userSettings?.language
  );
  const { t } = useTranslation();

  const availableLanguages = [
    { code: "he", name: t("general.languages.he"), flag: "il" },
    { code: "en", name: t("general.languages.en"), flag: "us" },
  ];

  const currentLanguage =
    availableLanguages.find((lang) => lang.code === userSelectedLanguage) ||
    availableLanguages[0];

  const handleLanguageChange = (languageCode) => {
    dispatch(setLanguage(languageCode));
    setShowLanguageDropdown(false);
  };

  return (
    <div className="relative">
      <Button
        variant="link"
        onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
        className={`flex items-center gap-2 w-full min-w-[120px] ${
          showTitle ? "!justify-between" : "!justify-end"
        }`}
      >
        <span className="flex items-center gap-2">
          {showTitle && t("general.languagesSelector")}{" "}
          <img
            src={`https://flagcdn.com/${currentLanguage.flag}.svg`}
            alt={currentLanguage.name}
            className="w-4"
          />
        </span>
        <FaChevronDown
          className={`transition-transform duration-200 ${
            showLanguageDropdown ? "rotate-180" : ""
          }`}
          size={12}
        />
      </Button>
      {showLanguageDropdown && (
        <div
          className={`absolute ${dropdownPosition} start-1 mb-1 w-full bg-white border border-gray-200 rounded-md shadow-lg z-10`}
        >
          {availableLanguages.map((language) => (
            <Button
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              variant={
                language.code === currentLanguage.code ? "primary" : "link"
              }
              className="w-full justify-between"
            >
              {language.name}
              <img
                src={`https://flagcdn.com/${language.flag}.svg`}
                alt={language.name}
                className="w-4"
              />
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LangSelector;
